import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ROUTE_ACTION_ENTITY_TYPE } from '@core/models/comments-v4.model';

import { CommentsConfigState } from './comments-config.state';

export const selectCommentsConfigState =
  createFeatureSelector<CommentsConfigState>('comments-config');

export const selectCommentableEntityTypes = createSelector(
  selectCommentsConfigState,
  (state) => state.entityTypes
);

export const selectIsRouteActionCommentable = createSelector(
  selectCommentableEntityTypes,
  (types) => types.includes(ROUTE_ACTION_ENTITY_TYPE)
);
